import React, { useState, useRef, useEffect } from "react";
import { Row, Col } from "reactstrap";
import { uThermMini } from "../icons";
import DropdownPointerHover from "../../components/DropdownPointerHover";
import ButtonPrimary from "../../components/ButtonPrimary";
import { IoMdClose } from "react-icons/io/index";
const positionRegion = {
  0: {
    0: {
      left: 39.93,
      top: 39.77,
      province: "พระนครศรีอยุธยา",
      region: "ภาคกลาง",
    },
    1: {
      left: 43.81,
      top: 37.98,
      province: "สระบุรี",
      region: "ภาคกลาง",
    },
    2: {
      left: 31.3,
      top: 44.89,
      province: "ราชบุรี",
      region: "ภาคกลาง",
    },
    3: {
      left: 41.37,
      top: 44.47,
      province: "สมุทรปราการ",
      region: "ภาคกลาง",
    },
    4: {
      left: 25.76,
      top: 14.6,
      province: "ลำพูน",
      region: "ภาคเหนือ",
    },
    5: {
      left: 39.93,
      top: 22.2,
      province: "พิษณุโลก",
      region: "ภาคเหนือ",
    },
    6: {
      left: 58.57,
      top: 25.63,
      province: "ขอนแก่น",
      region: "ภาคอีสาน",
    },
    7: {
      left: 53.67,
      top: 35.18,
      province: "นครราชสีมา",
      region: "ภาคอีสาน",
    },
    8: {
      left: 40.44,
      top: 88.22,
      province: "สงขลา",
      region: "ภาคใต้",
    },
    9: {
      left: 46.05,
      top: 46.51,
      province: "ชลบุรี",
      region: "ภาคตะวันออก",
    },
  },
  1: {
    0: {
      left: 61.38,
      top: 27.23,
      province: "พระนครศรีอยุธยา",
      region: "ภาคกลาง",
    },
    1: {
      left: 70.7,
      top: 21.28,
      province: "สระบุรี",
      region: "ภาคกลาง",
    },
    2: {
      left: 41.83,
      top: 44.15,
      province: "ราชบุรี",
      region: "ภาคกลาง",
    },
    3: {
      left: 64.56,
      top: 42.43,
      province: "สมุทรปราการ",
      region: "ภาคกลาง",
    },
  },
  2: {
    0: {
      left: 37.86,
      top: 40.41,
      province: "ลำพูน",
      region: "ภาคเหนือ",
    },
    1: {
      left: 64.01,
      top: 61.43,
      province: "พิษณุโลก",
      region: "ภาคเหนือ",
    },
  },
  3: {
    0: {
      left: 40,
      top: 45.92,
      province: "ขอนแก่น",
      region: "ภาคอีสาน",
    },
    1: {
      left: 30.9,
      top: 74.6,
      province: "นครราชสีมา",
      region: "ภาคอีสาน",
    },
  },
  4: {
    0: {
      left: 59.7,
      top: 70.03,
      province: "สงขลา",
      region: "ภาคใต้",
    },
  },
  5: {
    0: {
      left: 21.58,
      top: 40.05,
      province: "ชลบุรี",
      region: "ภาคตะวันออก",
    },
  },
};
export default function FactoryIcon({ region, province, factory }) {
  const [onOver, setOnOver] = useState(false);
  const [factoryItem, setFactory] = useState(factory[0]);
  const ref = useRef();
  // console.log(factory);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    setWidth(ref.current.clientWidth);
    setHeight(ref.current.clientHeight);
    return () => {};
  }, []);
  useEffect(() => {
    setFactory(factory[0]);

    return () => {};
  }, [factory]);

  return (
    <>
      <div
        className="box-pointer-hover"
        ref={ref}
        style={{
          left: `calc(${positionRegion[region][province]["left"]}% - ${width}px / 2)`,
          top: `calc(${positionRegion[region][province]["top"]}% - ${height}px)`,
          visibility: onOver ? "visible" : "hidden",
        }}
      >
        <ButtonPrimary
          text={<IoMdClose />}
          className={"button-pointer-hover-close"}
          onClick={() => {
            setOnOver(false);
          }}
        />
        <Row className="justify-content-space-between">
          <Col xl={10} lg={10} xs={9}>
            {factory.length > 1 ? (
              <DropdownPointerHover
                items={factory}
                itemCallback={(item, key) => {
                  setFactory(item);
                }}
              />
            ) : (
              <p className="txt-pointer-hover-title">
                {factoryItem["factory"]}
              </p>
            )}
          </Col>
        </Row>
        <div className="mt-1"></div>
        <Row>
          <Col>
            <p className="txt-pointer-hover-content">
              {factoryItem["address"]}
            </p>
          </Col>
        </Row>
        <div className="mt-1"></div>
        <Row>
          {factoryItem["device"].map((item , index) => {
            return (
              <Col key={index}>
                <div className="pointer-hover-col">
                  <img
                    src={uThermMini}
                    className="img-utherm-pointer-hover"
                  ></img>
                  <p className="txt-pointer-hover-utherm">{item}</p>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
      {factory.length > 1 && (
        <div
          style={{
            left: `calc(${positionRegion[region][province]["left"]}% + 9px)`,
            top: `calc(${positionRegion[region][province]["top"]}% + 9px)`,
          }}
          className="box-pointer-duplicated-factory"
        >
          {factory.length}
        </div>
      )}
      <svg
        onClick={() => {
          setOnOver(true);
        }}
        className="pointer-icon" //22.44% + 0.5257*92vh
        style={{
          left: `${positionRegion[region][province]["left"]}%`,
          top: `${positionRegion[region][province]["top"]}%`,
        }}
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18.196 18.2"
      >
        <g id="layer1" transform="translate(-32.766 -9.603)">
          <g id="g21" transform="translate(32.766 9.603)">
            <g id="g224" transform="translate(0)">
              <path
                id="path35"
                d="M-105.249,90.155c-.051-.064-.049-.066.015-.015a.256.256,0,0,1,.071.071C-105.162,90.244-105.2,90.223-105.249,90.155Zm-.035-.879a.255.255,0,0,1,.071-.071c.064-.051.066-.049.015.015S-105.284,89.31-105.284,89.277Zm1.828-1.949V85.607l.092-.137a1.016,1.016,0,0,1,.229-.229l.137-.092h9.482l.137.092a1.016,1.016,0,0,1,.229.229l.092.137v3.441h-10.4Zm1.85-.329c.094-.094.1-.126.1-.55s-.006-.456-.1-.55-.126-.1-.55-.1-.456.006-.55.1-.1.126-.1.55.006.456.1.55.126.1.55.1S-101.7,87.092-101.606,87Zm1.95,0c.094-.094.1-.126.1-.55s-.006-.456-.1-.55-.126-.1-.55-.1-.456.006-.55.1-.1.126-.1.55.006.456.1.55.126.1.55.1S-99.75,87.092-99.656,87Zm1.95,0c.094-.094.1-.126.1-.55s-.006-.456-.1-.55-.126-.1-.55-.1-.456.006-.55.1-.1.126-.1.55.006.456.1.55.126.1.55.1S-97.8,87.092-97.706,87Zm1.95,0c.094-.094.1-.126.1-.55s-.006-.456-.1-.55-.126-.1-.55-.1-.456.006-.55.1-.1.126-.1.55.006.456.1.55.126.1.55.1S-95.85,87.092-95.756,87Zm1.95,0c.094-.094.1-.126.1-.55s-.006-.456-.1-.55-.126-.1-.55-.1-.456.006-.55.1-.1.126-.1.55.006.456.1.55.126.1.55.1S-93.9,87.092-93.806,87Zm-11.443-2.693c-.051-.064-.049-.066.015-.015a.256.256,0,0,1,.071.071C-105.162,84.394-105.2,84.373-105.249,84.305Zm-.035-.879a.256.256,0,0,1,.071-.071c.064-.051.066-.049.015.015S-105.284,83.46-105.284,83.427Zm17.869-4.606c-.051-.064-.049-.066.015-.015a.256.256,0,0,1,.071.071C-87.328,78.91-87.361,78.889-87.415,78.821Zm-1.3-2.6c-.051-.064-.049-.066.015-.015s.089.086.056.086A.256.256,0,0,1-88.715,76.221Zm-8.734-2.966c-.051-.064-.049-.066.015-.015s.089.086.056.086a.256.256,0,0,1-.071-.071Zm3.5.056a.256.256,0,0,1,.071-.071c.064-.051.066-.049.015.015S-93.95,73.345-93.95,73.311Zm-3.534-.934a.256.256,0,0,1,.071-.071c.064-.051.066-.049.015.015S-97.484,72.41-97.484,72.377Zm3.57-.056c-.051-.064-.049-.066.015-.015a.256.256,0,0,1,.071.071C-93.828,72.41-93.861,72.389-93.914,72.321Z"
                transform="translate(105.402 -72.149)"
                fill="#eee"
              />
              <path
                id="path33"
                d="M-101.843,86.1c0-2.126,0-2.275.07-2.275.038,0,1.487-.567,3.22-1.259s3.182-1.259,3.222-1.259,1.465.559,3.167,1.242,3.145,1.252,3.208,1.264l.113.023v4.54h-1.3V84.936l-.092-.137a1.016,1.016,0,0,0-.229-.229l-.137-.092h-9.482l-.137.092a1.016,1.016,0,0,0-.229.229l-.092.137v3.441h-1.3Zm7.524-13.392a.644.644,0,0,1-.223-.993c.2-.234.236-.239,1.8-.239,1.588,0,1.612,0,1.813.267a.5.5,0,0,1,.117.383.5.5,0,0,1-.109.373c-.209.275-.225.277-1.826.276A5.711,5.711,0,0,1-94.319,72.71Z"
                transform="translate(102.489 -71.478)"
                fill="#f5af00"
              />
              <path
                id="path31"
                d="M-105.592,96.776a.846.846,0,0,1-.244-.209.5.5,0,0,1-.109-.376.578.578,0,0,1,.28-.542l.112-.084h6.71c6.638,0,6.712,0,6.845.081a.643.643,0,0,1,0,1.1c-.133.08-.215.081-6.8.091-6.109.009-6.674,0-6.8-.057Zm17.177-.257v-.325h-.325v-.65h.325v-1.95h-.325v-.65h.325v-1.95h-.325v-.65h.325v-1.95h-.325v-.65h.325v-1.95h-.325v-.659l.279.016a.632.632,0,0,1,.421.124c.3.227.275-.242.275,5.979v5.59h-.65Zm-8.338-8.969-.762-.308v-7.3h2.6v2.591l-.283.016a.645.645,0,0,0-.588.293c-.082.11-.084.16-.095,2.567a17.012,17.012,0,0,1-.061,2.451c-.027,0-.393-.143-.812-.312Z"
                transform="translate(105.96 -78.645)"
                fill="#009fc7"
              />
              <path
                id="path29"
                d="M-77.756,111.171a.082.082,0,0,1,.078,0c.013.014-.01.023-.053.021s-.057-.012-.025-.025Zm.5-.483c0-.047.012-.057.025-.025a.082.082,0,0,1,0,.078C-77.25,110.755-77.26,110.731-77.258,110.688Zm2.637-.464V109.9h.325v.65h-.325Zm-2.637.179c0-.047.012-.057.025-.025a.082.082,0,0,1,0,.078C-77.25,110.47-77.26,110.446-77.258,110.4Zm-.5-.492a.082.082,0,0,1,.078,0c.013.013-.01.023-.053.021s-.057-.012-.025-.025Zm3.136-2.288V107.3h.325v.65h-.325Zm-14.224.213c-.051-.064-.049-.066.015-.015s.089.086.056.086a.255.255,0,0,1-.071-.071Zm1.061.056a.256.256,0,0,1,.071-.071c.064-.051.066-.049.015.015S-87.783,107.927-87.783,107.893Zm.889-.056c-.051-.064-.049-.066.015-.015a.256.256,0,0,1,.071.071C-86.808,107.927-86.841,107.905-86.894,107.838Zm1.061.056a.256.256,0,0,1,.071-.071c.064-.051.066-.049.015.015S-85.833,107.927-85.833,107.893Zm.889-.056c-.051-.064-.049-.066.015-.015s.089.086.056.086A.256.256,0,0,1-84.944,107.838Zm1.061.056a.256.256,0,0,1,.071-.071c.064-.051.066-.049.015.015s-.086.089-.086.056Zm.889-.056c-.051-.064-.049-.066.015-.015s.089.086.056.086A.256.256,0,0,1-82.994,107.838Zm1.061.056a.256.256,0,0,1,.071-.071c.064-.051.066-.049.015.015S-81.933,107.927-81.933,107.893Zm.889-.056c-.051-.064-.049-.066.015-.015s.089.086.056.086A.255.255,0,0,1-81.045,107.838Zm1.061.056a.256.256,0,0,1,.071-.071c.064-.051.066-.049.015.015S-79.983,107.927-79.983,107.893Zm-8.9-1.1a.255.255,0,0,1,.071-.071c.064-.051.066-.049.015.015S-88.88,106.83-88.88,106.8Zm1.132-.056c-.051-.064-.049-.066.015-.015a.255.255,0,0,1,.071.071C-87.661,106.83-87.694,106.808-87.748,106.741Zm.818.056a.255.255,0,0,1,.071-.071c.064-.051.066-.049.015.015S-86.93,106.83-86.93,106.8Zm1.132-.056c-.051-.064-.049-.066.015-.015a.255.255,0,0,1,.071.071C-85.711,106.83-85.744,106.808-85.8,106.741Zm.818.056a.255.255,0,0,1,.071-.071c.064-.051.066-.049.015.015S-84.98,106.83-84.98,106.8Zm1.132-.056c-.051-.064-.049-.066.015-.015a.256.256,0,0,1,.071.071C-83.761,106.83-83.795,106.808-83.848,106.741Zm.818.056a.255.255,0,0,1,.071-.071c.064-.051.066-.049.015.015S-83.03,106.83-83.03,106.8Zm1.132-.056c-.051-.064-.049-.066.015-.015a.255.255,0,0,1,.071.071C-81.811,106.83-81.845,106.808-81.9,106.741Zm.818.056a.255.255,0,0,1,.071-.071c.064-.051.066-.049.015.015S-81.08,106.83-81.08,106.8Zm1.132-.056c-.051-.064-.049-.066.015-.015a.255.255,0,0,1,.071.071C-79.861,106.83-79.895,106.808-79.948,106.741Zm5.327-1.716V104.7h.325v.65h-.325Zm0-2.6V102.1h.325v.65h-.325Zm-7.5-.136-.934-.376-.013-.15c-.007-.083,0-.15.01-.15s.365.137.783.3.774.3.791.3.036-1.1.042-2.455c.011-2.407.013-2.457.095-2.567a.629.629,0,0,1,.512-.287c.212-.016.214-.015.094.041a.7.7,0,0,0-.343.365c-.029.077-.043.976-.043,2.732,0,1.44-.014,2.617-.03,2.616S-81.6,102.5-82.116,102.289Zm7.5-2.464V99.5h.325v.65h-.325Z"
                transform="translate(91.516 -93)"
                fill="#0081a9"
              />
              <path
                id="path27"
                d="M-105.679,130.344a.628.628,0,0,1-.2-1c.119-.133.442-.271,3.493-1.489,1.849-.738,3.416-1.342,3.483-1.342s1.634.6,3.483,1.342a23.955,23.955,0,0,1,3.491,1.48.646.646,0,0,1-.481,1.078c-.077,0-1.422-.518-3.27-1.259-1.727-.693-3.172-1.259-3.211-1.259s-1.489.567-3.222,1.259c-2.051.82-3.2,1.259-3.291,1.258A.751.751,0,0,1-105.679,130.344Z"
                transform="translate(106.049 -118.061)"
                fill="#c60a4e"
              />
              <path
                id="path25"
                d="M-77.765,111.2a.661.661,0,0,0,.322-.558.661.661,0,0,0-.322-.558l-.137-.092h3.059v1.3H-77.9Zm-.328-2.67V107.39h3.25v2.275h-3.25Zm-10.931-.606c-.116-.116-.119-.129-.119-.531s0-.416.119-.531.129-.119.531-.119.416,0,.531.119.119.129.119.531,0,.416-.119.531-.129.119-.531.119S-88.909,108.037-89.024,107.921Zm1.95,0c-.116-.116-.119-.129-.119-.531s0-.416.119-.531.129-.119.531-.119.416,0,.531.119.119.129.119.531,0,.416-.119.531-.129.119-.531.119S-86.959,108.037-87.074,107.921Zm1.95,0c-.116-.116-.119-.129-.119-.531s0-.416.119-.531.129-.119.531-.119.416,0,.531.119.119.129.119.531,0,.416-.119.531-.129.119-.531.119S-85.009,108.037-85.124,107.921Zm1.95,0c-.116-.116-.119-.129-.119-.531s0-.416.119-.531.129-.119.531-.119.416,0,.531.119.119.129.119.531,0,.416-.119.531-.129.119-.531.119S-83.059,108.037-83.174,107.921Zm1.95,0c-.116-.116-.119-.129-.119-.531s0-.416.119-.531.129-.119.531-.119.416,0,.531.119.119.129.119.531,0,.416-.119.531-.129.119-.531.119S-81.109,108.037-81.225,107.921Zm3.131-1.664v-.808l.143-.027a.673.673,0,0,0,.476-.455l.047-.177h2.583v2.275h-3.25Zm.633-1.928a.735.735,0,0,0-.157-.284c-.117-.131-.324-.224-1.919-.856l-1.787-.709-.013-.145-.013-.145h6.5v2.275h-2.591Zm-3.883-3.6V99.59h6.5v2.275h-6.5Zm.008-2.394c.013-1.023.016-1.033.292-1.239.111-.083.147-.084,2.922-.084,2.738,0,2.814,0,2.945.081a.806.806,0,0,1,.223.223c.083.133.089.2.1,1.046l.013.9h-6.51Z"
                transform="translate(91.739 -93.09)"
                fill="#094f76"
              />
              <path
                id="path23"
                d="M-35.093,122.257v-.162h3.25v.325h-3.25Zm0-2.6v-.162h3.25v.325h-3.25Zm.621-2.61a.706.706,0,0,0-.161-.281,16.127,16.127,0,0,0-1.912-.827l-1.8-.718V114.9l.152.059,1.8.712c1.459.578,1.66.669,1.777.8a.732.732,0,0,1,.157.283l.026.136h2.591v.325h-2.583Zm-3.871-2.59v-.162h6.5v.325h-6.5Zm0-2.6v-.162h6.5v.325h-6.5Z"
                transform="translate(48.739 -105.52)"
                fill="#003159"
              />
            </g>
          </g>
        </g>
      </svg>
    </>
  );
}
